import React from 'react';
import {validatable} from 'components/utils';
import DataSelected from './DataSelected.jsx';
import ItemChildren from './ItemChildren.jsx';
import ItemParents from './ItemParents.jsx';
import {arrayObjectIndexOf, getAllChildren, removeAllChildren} from './method.jsx';
import ShowIf from './ShowIf.jsx';
require('./_Style.scss');
class ReactTreeSelect extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      dataOptions: this.props.dataOptions,
      dataSelected: this.props.dataSelected,
      optionOpened: false,
      propertyChildren: this.props.propertyChildren,
      thanhTraCQQL: this.props.thanhTraCQQL,
      propertyParent: this.props.propertyParent,
      selectAllChildren: false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      dataOptions: nextProps.dataOptions,
      dataSelected: nextProps.dataSelected,
      propertyChildren: nextProps.propertyChildren,
      thanhTraCQQL: nextProps.thanhTraCQQL,
      propertyParent: nextProps.propertyParent,
    });
    if (this.props.selectAllChildren != nextProps.selectAllChildren) {
      this.selectAllChildren(nextProps.selectAllChildren);
    }
  }

  getParents(data) {
    let DataFillter = [...data];

    let DataParents = [];

    DataFillter.map((state, i) => {
      let draf = [...data];
      if (state[this.state.propertyChildren] != null) {
        let dataCheck = draf.filter(item => {
          return item[this.state.propertyParent] == state[this.state.propertyChildren][this.state.propertyParent]
        })
        if (dataCheck.length > 0) {
          // Do nothing
        } else {
          DataParents[DataParents.length] = DataFillter[i];
        }
      } else {
        DataParents[DataParents.length] = DataFillter[i];
      }
    })


    let dataRender = DataParents.map((item, i) => {
      return (
        <ItemParents key={i} dataSelected={this.state.dataSelected} label={item.ten} value={item[this.state.propertyParent]} selectedOption={this.selectedOption.bind(this)} removeOption={this.removeOption.bind(this)}>
          {
            this.getChildren(item[this.state.propertyParent], data)
          }
        </ItemParents>
      )
    });

    return dataRender;
  }

  getChildren(id, data) {
    let DataFillter = [...data];

    let DataChildren = DataFillter.filter(state => {
      return state[this.state.propertyChildren] && state[this.state.propertyChildren][this.state.propertyParent] == id
    });

    let dataRender = ('')
    if (DataChildren.length > 0) {
      dataRender =  DataChildren.map((item, i) => {
        return (
          <ItemChildren key={i} dataQuan={item.coQuanQuanLyCha} dataSelected={this.state.dataSelected} label={item.ten} value={item[this.state.propertyParent]} selectedOption={this.selectedOption.bind(this)} removeOption={this.removeOption.bind(this)}>
            {
              this.getChildren(item[this.state.propertyParent], data)
            }
          </ItemChildren>
        )
      });
    }

    return dataRender;
  }

  selectedOption(data) {
    let dataSelected = [...this.state.dataSelected];
    dataSelected[dataSelected.length] = {
      label: data.label,
      value: data.value
    };
    this.state.dataSelected = dataSelected;
    this.setState({
      dataSelected: this.state.dataSelected
    },()=> {
      this.props.onChange(this.state.dataSelected);
    })
  }

  removeOption(data) {
    let dataSelected = [...this.state.dataSelected];
    let index = arrayObjectIndexOf(dataSelected, data.value, "value");
    dataSelected.splice(index, 1);
    this.state.dataSelected = dataSelected;
    this.setState({
      dataSelected: this.state.dataSelected
    },()=> {
      this.props.onChange(this.state.dataSelected);
    });
  }

  removeSelected(data) {
    let dataSelected = [...this.state.dataSelected];
    let index = arrayObjectIndexOf(dataSelected, data.value, "value");
    dataSelected.splice(index, 1);
    this.state.dataSelected = dataSelected;
    this.setState({
      dataSelected: this.state.dataSelected
    },()=> {
      this.props.onChange(this.state.dataSelected);
    });
  }


  selectAllChildren(isCheck) {
    let dataSelected = [];
    if (isCheck) {
      dataSelected = getAllChildren(this.state.data, this.state.dataSelected, this.state.propertyParent, this.state.propertyChildren);
    } else {
      dataSelected = removeAllChildren(this.state.dataSelected);
    }
    this.setState({
      dataSelected: dataSelected,
      selectAllChildren: isCheck
    },()=> {
      this.props.onChange(this.state.dataSelected);
    })
  }

  toggleOption(e) {

    if (!this.state.optionOpened) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }

    this.setState({
      optionOpened: !this.state.optionOpened
    })
  }

  closeOption(){
    this.setState({
      optionOpened: false
    })
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  clearSelected() {
    this.setState({
      dataSelected: []
    },()=> {
      this.props.onChange(this.state.dataSelected);
    })
  }

  render() {
    let dataRender = this.getParents(this.state.data);
    return (
      <section className={this.state.optionOpened ? 'rs-wrapper open' : 'rs-wrapper'} id='node' ref={node => { this.node = node; }}>
        <DataSelected toggleOption={this.toggleOption.bind(this)} dataOptions={this.props.dataOptions} thanhTraCQQL={this.props.thanhTraCQQL} removeSelected={this.removeSelected.bind(this)} dataSelected={this.state.dataSelected}/>
        <ShowIf condition={this.state.dataSelected.length > 1}>
          <span className='rs-clear-all' onClick={this.clearSelected.bind(this)}>×</span>
        </ShowIf>
        <ShowIf condition={this.state.dataSelected.length == 0}>
          <span className='rs-place-holder'>{this.props.placeHolder}</span>
        </ShowIf>
        <div className={this.state.optionOpened ? 'rs-wrap-options' : 'rs-wrap-options hidden'}>
          {dataRender}
        </div>
      </section>
    )
  }
}

ReactTreeSelect.defaultProps = {
  data: [],
  dataSelected: [],
  selectAllChildren: false,
  placeHolder: '--Chọn--',
  propertyChildren: '',
  propertyParent: ''
}


export default validatable(ReactTreeSelect);



// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/ReactTreeSelect.jsx